module.exports = __webpack_public_path__ + "static/media/ejemplo.259a0b9d.csv";